import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_API_KEY = 'scheduler/config/<id>';

export function useSchedulerConfigQuery({
	id,
	enabled = true,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IMeetingConfigResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `scheduler/config/${encodeURIComponent(id)}`,
				}),
				'GET'
			),
		queryKey: [BASE_API_KEY, id, impersonationContext],
		enabled: enabled && Boolean(id),
	});
}
